import { render, staticRenderFns } from "./TradingData.vue?vue&type=template&id=3c4e0807&"
import script from "./TradingData.vue?vue&type=script&lang=js&"
export * from "./TradingData.vue?vue&type=script&lang=js&"
import style0 from "./TradingData.vue?vue&type=style&index=0&id=3c4e0807&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports